export default __webpack_public_path__ + "static/media/image29tum.dd60882a.jpg";